<template>
  <div class="max-w-4xl mx-auto px-6 py-10 text-gray-800">
    <h1 class="text-3xl font-bold mb-6 text-center">Conditions Générales de Vente (CGV)</h1>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">1. Objet</h2>
      <p>
        Les présentes Conditions Générales de Vente régissent les ventes de prestations de services via la plateforme BookMySalon.
        En réservant une prestation, le client accepte sans réserve les présentes CGV.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">2. Modalités de Paiement</h2>
      <p>
        Le paiement des prestations peut être réalisé en ligne via notre partenaire Stripe, ou directement en salon selon les conditions fixées par le professionnel.
        Certains salons peuvent exiger un acompte à la réservation, déduit du montant final le jour du rendez-vous.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">3. Droit de Rétractation</h2>
      <p>
        Conformément à l’article L221-28 du Code de la consommation, le droit de rétractation ne s’applique pas aux prestations de services liées à une date précise.
        Toutefois, un client peut annuler un rendez-vous selon les conditions suivantes :
      </p>
      <ul class="list-disc pl-6 mt-2">
        <li>Annulation plus de 24h avant : remboursement total de l’acompte.</li>
        <li>Annulation entre 24h et 4h avant : 50% de l’acompte remboursé.</li>
        <li>Annulation moins de 4h avant ou absence : aucun remboursement.</li>
      </ul>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">4. Politique de Remboursement</h2>
      <p>
        Les remboursements sont effectués uniquement selon les conditions prévues au moment de la réservation et conformément aux délais d’annulation.
        Le salon se réserve le droit d'accepter ou non un remboursement exceptionnel.
      </p>
      <p class="mt-2">
        En cas d’annulation par le salon, le client est remboursé intégralement sous 5 à 10 jours ouvrés via Stripe.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">5. Traitement du Paiement</h2>
      <p>
        Tous les paiements en ligne sont sécurisés via la plateforme Stripe. BookMySalon ne stocke pas les données bancaires des clients.
        La transaction est traitée sur une interface sécurisée cryptée (SSL).
      </p>
      <p class="mt-2">
        En cas de problème de paiement ou de débit frauduleux, veuillez contacter immédiatement notre support via
        <a href="mailto:support@bookmysalon.fr" class="text-blue-600 underline">support@bookmysalon.fr</a>.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">6. Litiges et Réclamations</h2>
      <p>
        En cas de litige, le client peut adresser une réclamation par e-mail à notre service support.
        À défaut de résolution amiable, le litige sera soumis à la juridiction compétente du lieu de domicile du consommateur.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">7. Comportement et blocage</h2>
      <p>
        En cas d’abus ou de non-présentation répétée, un salon peut signaler un client. BookMySalon se réserve le droit de bloquer ou restreindre le compte d’un client.
      </p>
    </section>

    <section class="text-sm text-gray-500 mt-10 text-center">
      Dernière mise à jour : 24 juin 2025
    </section>
  </div>
</template>

<script setup>
// Aucun script requis ici
</script>

<style scoped>
/* Aucun style additionnel nécessaire avec Tailwind */
</style>
